import React, { Component } from "react";
import { withTranslation } from "react-i18next";
import moment from "moment";
import posthog from "posthog-js";
import { bindActionCreators } from "redux";
import { connect } from "react-redux";
import { Row, Col, Container } from "react-bootstrap";
import * as timeOffActions from "./timeOffActions";
import * as customFn from "../../Global/CustomFunctions";
import userPic from "./Images/user.png";
import * as officeActions from "../company/companyOffices/officeActions";
import { onGetDepartments, departments } from "../users/userActions";
import { Table, Modal, Popup } from "semantic-ui-react";
import FetchingSpinner from "../../common/FetchingSpinner";
import {
  getSelectedOffice,
  getSelectedCompany,
  GetCompAndOffice,
  updateDateState,
  clearLocalStorageItem,
  updateState,
  updateDropDownState,
} from "../../Global/CustomFunctions";
import { LocalStorage } from "../../Global/Constant";
import { Common, formatMaxAbsentErrors, showMaxAbsentErrors } from "../../../utils";
import RenderWeekHeader from "./calender/wallChart/renderWeekHeader";
import RenderHeader from "./calender/wallChart/renderHeader";
import TImeOffModal from "./timeOffModal";
import BulkGroupLeaveModal from "./bulkGroupLeaveModal";
import WallChart from "./calender/wallChart/wallChart";
import { isSubscriptionSuspended, fetchSubscriptionData } from "../../../utils/subscriptionUtils";
import SubscriptionRestriction from "../../common/subscriptionRestriction/SubscriptionRestriction";
import CommonPageHeader from "../../common/ui/page-header/CommonPageHeader";
import { getUserInfo, axiosBasic } from "../../../api/axios";
import { config } from "../../../api/endPoints";
import "./calender/calander.css";
import "./calender/group-styles.css";

class EmployeesCalender extends Component {
  constructor(props) {
    super(props);
    this.state = {
      date: moment().startOf("month"),
      Loading: false,
      office: getSelectedOffice(),
      company: getSelectedCompany(),
      isActive: true,
      isModalOpen: false,
      timeOffModal: props.timeOffModal,
      timeOffModalErrors: props.timeOffModalErrors,
      endingLeaveOptions: props.endingLeave,
      startingLeaveOptions: props.startingLeave,
      hasUserMadeChanges: false, // Track if user has made changes in edit mode
      currentMonth: "",
      currentYear: "",
      isLoadingLeaveTypes: false,
      // Pagination state
      currentPage: 1,
      pageSize: 50,
      hasMore: true,
      isLoadingMore: false,
      isSubscriptionSuspended: false,
      lastUpdate: null, // Track last update to force re-render when needed
      selectedDepartmentId: "all", // Department filter state
      isDepartmentDropdownOpen: false, // Department dropdown open state
      showFilterModal: false, // Filter modal visibility
      filterSortBy: "firstName", // Sort by: firstName, lastName, department
      filterAccountType: "all", // Account type: all, departmentManagers, usersIApprove, myFavourites
      selectedDepartments: ["all"], // Selected departments (array for multiple selection)
      isUpdatingFavorite: false, // Track when favorite is being updated
      // Bulk modal state
      isBulkModalOpen: false,
      bulkLeaveModal: {
        DepartmentId: null,
        LeaveTypeId: null,
        StartDate: "",
        EndDate: "",
        LeaveNote: "",
        StartingLeave: 0,
        EndingLeave: 0,
      },
      isLoadingBulkLeaveTypes: false,
      isLoadingBulkDepartments: false,
      companyLeaveTypes: [], // Store company leave types for bulk modal
      isFormLoading: false, // Loading state for form submission
    };
    this.handleCloseModal = this.handleCloseModal.bind(this);
    this.updateTimeOffModalState = this.updateTimeOffModalState.bind(this);
    this.handleDateChange = this.handleDateChange.bind(this);
    this.bookTimeOff = this.bookTimeOff.bind(this);
    this.updateDropDownState = this.updateDropDownState.bind(this);
    this.previousEmployeeCount = 0;
    this.lastScrollTop = 0;
    this.scrollDirection = 'down';
    this.lastLoadStartTime = null;
    this.lastLoadCallTime = 0;
  }

  componentDidUpdate(prevProps) {
    // Update hasMore based on pagination from API
    if (this.props.pagination && prevProps.pagination !== this.props.pagination) {
      // Only update hasMore if hasNextPage is explicitly defined (true or false)
      // Don't set to false if it's undefined/null
      const hasNextPage = this.props.pagination.hasNextPage;
      if (hasNextPage !== undefined) {
        this.setState({
          hasMore: hasNextPage === true,
          currentPage: this.props.pagination.currentPage || this.state.currentPage
        });
      } else {
        // If hasNextPage is undefined, only update currentPage, preserve hasMore
        this.setState({
          currentPage: this.props.pagination.currentPage || this.state.currentPage
        });
      }
    }

    // Fallback: Check if we got fewer results than pageSize, meaning no more data
    // Only do this if we're loading more and pagination info is not available
    // Note: This is a backup check - loadMoreEmployees now resets isLoadingMore immediately
    if (this.state.isLoadingMore && prevProps.employeeLeaves && !this.props.pagination) {
      const currentCount = this.props.employeeLeaves?.length || 0;
      const previousCount = prevProps.employeeLeaves?.length || 0;
      const newItemsCount = currentCount - previousCount;

      // Only set hasMore to false if we got fewer items AND we actually got some new items
      // If newItemsCount is 0, it might mean Redux hasn't updated yet, so don't set hasMore to false
      if (newItemsCount > 0 && newItemsCount < this.state.pageSize) {
        // Got fewer items than pageSize, so no more data
        this.setState({ hasMore: false, isLoadingMore: false });
      } else if (newItemsCount >= this.state.pageSize) {
        // Got a full page, ensure isLoadingMore is reset
        this.setState({ isLoadingMore: false });
      }
      // Update previousEmployeeCount for next load
      this.previousEmployeeCount = currentCount;
    }

    // Update workplace information if it changes
    if (prevProps.company !== this.props.company && this.props.company) {
      this.setState({ company: this.props.company });
    }

    // Ensure calendar re-renders when employeeLeaves changes after booking/editing leave
    // This handles cases where some browsers don't properly detect Redux state changes
    // IMPORTANT: Only update lastUpdate, don't modify hasMore or pagination state here
    if (prevProps.employeeLeaves !== this.props.employeeLeaves) {
      const prevLength = prevProps.employeeLeaves?.length || 0;
      const currLength = this.props.employeeLeaves?.length || 0;

      // If the reference changed (which Redux should ensure), trigger a state update
      // to force re-render in browsers that may not detect the prop change
      // This is especially important after booking/editing leaves
      // Only update lastUpdate, preserve hasMore and pagination state
      if (prevLength !== currLength) {
        // Use a timestamp-based state update to trigger re-render without forceUpdate
        // This is safer and more React-friendly than forceUpdate
        // Preserve hasMore state to prevent breaking infinite scroll
        this.setState(prevState => ({
          lastUpdate: Date.now(),
          // Preserve hasMore state - don't reset it here
          hasMore: prevState.hasMore
        }));
      } else if (this.props.employeeLeaves && prevProps.employeeLeaves) {
        // Even if length is the same, the data might have changed (e.g., leave updated)
        // Check if any employee's leaves have changed by comparing a sample
        const prevSample = prevProps.employeeLeaves[0]?.userLeaves?.length || 0;
        const currSample = this.props.employeeLeaves[0]?.userLeaves?.length || 0;
        if (prevSample !== currSample) {
          this.setState(prevState => ({
            lastUpdate: Date.now(),
            // Preserve hasMore state - don't reset it here
            hasMore: prevState.hasMore
          }));
        }
      }
    }
  }

  // Helper function to get current filter values
  getCurrentFilterValues = () => {
    const selectedDeptIds = this.state.selectedDepartments.filter(id => id !== "all");
    // Don't use || operator as it will use "all" for falsy values - check explicitly
    const accountType = this.state.filterAccountType !== undefined && this.state.filterAccountType !== null
      ? this.state.filterAccountType
      : "all";
    const sortBy = this.state.filterSortBy !== undefined && this.state.filterSortBy !== null
      ? this.state.filterSortBy
      : "firstName";
    return {
      departmentIds: selectedDeptIds.length > 0 ? selectedDeptIds : null,
      accountType: accountType,
      sortBy: sortBy
    };
  }

  componentDidMount() {
    // Load employees immediately so loader shows and data appears without waiting for subscription.
    // Reset pagination and load first page (ONLY 50 records initially)
    // Use the current month's date for the API call (add 1 day like other handlers)
    const selectedDate = moment(this.state.date).add(1, 'days');
    const filters = this.getCurrentFilterValues();
    this.setState({ currentPage: 1, hasMore: true, isLoadingMore: false });

    this.props.timeOff.getEmployeeLeaves(
      selectedDate._d,
      1,
      this.state.pageSize,
      false,
      null, // departmentId (deprecated)
      filters.departmentIds,
      filters.accountType,
      filters.sortBy
    )
      .then((response) => {
        // Update hasMore based on pagination response
        if (response?.pagination) {
          const hasNextPage = response.pagination.hasNextPage === true;
          this.setState({ hasMore: hasNextPage });
        } else {
          // If no pagination info, check data length
          const dataLength = response?.data?.length || this.props.employeeLeaves?.length || 0;
          if (dataLength < this.state.pageSize) {
            this.setState({ hasMore: false });
          } else if (dataLength === this.state.pageSize) {
            // Got exactly pageSize, might have more
            this.setState({ hasMore: true });
          }
        }
      })
      .catch((error) => {
        // Error in initial load - silently handle
      });

    // Only call the API if we have a valid office
    if (this.state.office?.id) {
      this.props.officeActions.onGetOfficeBusinessDays(this.state.office.id);
    }

    // Fetch departments for filter
    // this.props.dispatch(onGetDepartments(true)); // Old endpoint - commented out
    this.fetchUserDepartments(); // Using new UserDepartments endpoint

    const date = new Date();
    const monthNames = [
      "January",
      "February",
      "March",
      "April",
      "May",
      "June",
      "July",
      "August",
      "September",
      "October",
      "November",
      "December",
    ];
    const month = monthNames[date.getMonth()];
    const year = date.getFullYear();

    this.setState({
      currentMonth: month,
      currentYear: year,
    });

    // Find the actual scrollable container (sidebar-pusher, not window)
    // The layout has a fixed sidebar and the main content area scrolls
    this.scrollContainer = document.querySelector('.sidebar-pusher') ||
      document.querySelector('.pusher') ||
      window; // Fallback to window if not found

    // Add scroll event listener to the actual scrollable container
    this.scrollContainer.addEventListener('scroll', this.handleScroll, { passive: true });

    // Add click outside handler for department dropdown
    this.handleClickOutside = (event) => {
      if (this.state.isDepartmentDropdownOpen &&
        !event.target.closest('.department-filter-wrapper')) {
        this.setState({ isDepartmentDropdownOpen: false });
      }
    };
    document.addEventListener('click', this.handleClickOutside);

    // Check subscription in background (do not block initial employee load or loader).
    fetchSubscriptionData()
      .then((subscriptionData) => {
        if (subscriptionData && isSubscriptionSuspended(subscriptionData)) {
          this.setState({ isSubscriptionSuspended: true });
        }
      })
      .catch(() => {
        // Error checking subscription status - silently fail
      });
  }

  componentWillUnmount() {
    this.props.timeOff.clearMonthlyLeaves();
    if (!this.props.history.location.pathname.endsWith("calender"))
      clearLocalStorageItem(LocalStorage.leaveTypes);

    // Clear validation timeout to prevent memory leaks
    if (this.validationTimeout) {
      clearTimeout(this.validationTimeout);
    }

    // Remove scroll event listener from the scrollable container
    if (this.handleScroll && this.scrollContainer) {
      this.scrollContainer.removeEventListener('scroll', this.handleScroll);
    }

    // Clear scroll timeout to prevent memory leaks
    if (this.scrollTimeout) {
      clearTimeout(this.scrollTimeout);
    }

    // Remove click outside handler
    if (this.handleClickOutside) {
      document.removeEventListener('click', this.handleClickOutside);
    }
  }

  // Fetch departments for filter: GetDepartmentsWithUsersByOffice(officeId) -> show department names; selection uses departmentIds in existing flow
  fetchUserDepartments = () => {
    const officeId = this.state.office?.id ?? this.state.office?.Id;
    if (!officeId) {
      this.props.dispatch(departments([[]]));
      return;
    }
    const { Department } = config.REST_API;
    const url = `${Department.GetDepartmentsWithUsersByOffice}?officeId=${officeId}`;
    axiosBasic
      .get(url)
      .then((response) => {
        const { success, data, message } = response.data;
        if (success && Array.isArray(data)) {
          const normalized = data.map((i) => {
            const id = i.departmentId ?? i.id ?? i.value;
            const name = i.departmentName ?? i.name ?? i.text ?? "";
            return { key: id, text: name, value: id };
          });
          this.props.dispatch(departments([normalized]));
        } else {
          if (!success && message) Common.showErrorMessage(message);
          this.props.dispatch(departments([[]]));
        }
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("wallChartGetDepartmentsWithUsersByOffice", {
            type: "exception",
            success: false,
            reason: error?.response?.data?.message ?? error?.message ?? "Failed to load departments",
            status: error?.response?.status,
            officeId,
          });
        }
        Common.showErrorMessage(error);
        this.props.dispatch(departments([[]]));
      });
  };

  handleScroll = () => {
    // Check scroll position immediately on every scroll event
    // This ensures we catch fast scrolling and don't miss the trigger point
    this.checkScrollAndLoad();
  };

  checkScrollAndLoad = () => {
    // Get the scrollable container (sidebar-pusher or window)
    const container = this.scrollContainer || window;
    const isWindow = container === window;

    // Get scroll position from the actual scrollable container
    let scrollTop, scrollHeight, clientHeight;

    if (isWindow) {
      // Window scroll
      scrollTop = window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      scrollHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight
      );
      clientHeight = window.innerHeight ||
        document.documentElement.clientHeight ||
        0;
    } else {
      // Container scroll (sidebar-pusher)
      scrollTop = container.scrollTop || 0;
      scrollHeight = container.scrollHeight || 0;
      clientHeight = container.clientHeight || 0;
    }

    // Track scroll direction for debugging/optimization
    if (scrollTop > this.lastScrollTop) {
      this.scrollDirection = 'down';
    } else if (scrollTop < this.lastScrollTop) {
      this.scrollDirection = 'up';
    }
    this.lastScrollTop = scrollTop;

    // Calculate distance from bottom
    // When at top: scrollTop = 0, distanceFromBottom = scrollHeight - clientHeight (large number)
    // When at bottom: scrollTop = scrollHeight - clientHeight, distanceFromBottom = 0 (or small)
    const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);

    // Use pagination from props if available, otherwise fall back to state
    const hasMore = this.props.pagination?.hasNextPage !== undefined
      ? this.props.pagination.hasNextPage
      : this.state.hasMore;

    // Simplified check: are we near the bottom?
    // distanceFromBottom should be a small positive number when near bottom
    // At top: distanceFromBottom = scrollHeight - clientHeight (large number)
    // At bottom: distanceFromBottom ≈ 0 (small number)
    // Increased threshold to 800px to trigger much earlier for fast scrolling
    const isNearBottom = distanceFromBottom <= 800 && distanceFromBottom >= 0;

    // Only prevent loading if we're at the very top (scrollTop is 0 or very small)
    // This prevents initial auto-load but allows continuous scrolling
    const isAtTop = scrollTop <= 5;

    // Load more if conditions are met
    // Simplified logic: if we're near bottom, have more data, not loading, and not at top
    // Throttle the actual load call to prevent too many rapid API requests
    const now = Date.now();
    const timeSinceLastLoad = now - this.lastLoadCallTime;
    const canLoadNow = timeSinceLastLoad >= 200 || this.lastLoadCallTime === 0;

    if (
      isNearBottom &&
      !isAtTop &&
      hasMore === true &&
      !this.state.isLoadingMore &&
      !this.props.Loading &&
      canLoadNow
    ) {
      this.lastLoadCallTime = now;
      this.loadMoreEmployees();
    }
  };

  loadMoreEmployees = () => {
    // Use pagination from props if available, otherwise fall back to state
    const hasMore = this.props.pagination?.hasNextPage !== undefined
      ? this.props.pagination.hasNextPage
      : this.state.hasMore;

    // Prevent duplicate loads - but allow if we've been loading for more than 3 seconds (stuck state)
    const isLoadingStuck = this.state.isLoadingMore &&
      this.lastLoadStartTime &&
      (Date.now() - this.lastLoadStartTime) > 3000;

    if (this.state.isLoadingMore && !isLoadingStuck) {
      return;
    }

    if (!hasMore) {
      return;
    }

    // Store the current count before loading more
    const currentCountBeforeLoad = this.props.employeeLeaves?.length || 0;
    this.previousEmployeeCount = currentCountBeforeLoad;

    const nextPage = this.state.currentPage + 1;
    this.lastLoadStartTime = Date.now();
    this.setState({ isLoadingMore: true, currentPage: nextPage });

    const selectedDate = moment(this.state.date).add(1, 'days');
    const filters = this.getCurrentFilterValues();
    this.props.timeOff.getEmployeeLeaves(
      selectedDate._d,
      nextPage,
      this.state.pageSize,
      true, // loadMore flag
      null, // departmentId (deprecated)
      filters.departmentIds,
      filters.accountType,
      filters.sortBy
    ).then((response) => {
      // Update hasMore based on pagination response
      if (response?.pagination) {
        const hasNextPage = response.pagination.hasNextPage === true;
        this.setState({
          isLoadingMore: false,
          hasMore: hasNextPage,
          currentPage: response.pagination.currentPage || nextPage
        }, () => {
          // After state update, check if we're still near bottom and need to load more
          // This handles continuous scrolling scenarios
          if (hasNextPage) {
            setTimeout(() => {
              this.checkAndLoadIfNearBottom();
            }, 100);
          }
        });
      } else {
        // Fallback: check if we got fewer results than pageSize
        // First, reset isLoadingMore immediately to allow subsequent loads
        this.setState({ isLoadingMore: false });

        // Use a small delay to ensure Redux state has updated, then check for more data
        setTimeout(() => {
          const currentCount = this.props.employeeLeaves?.length || 0;
          const previousCount = this.previousEmployeeCount || currentCountBeforeLoad;
          const newItemsCount = currentCount - previousCount;

          // Only set hasMore to false if we're certain there's no more data
          // If newItemsCount is 0, it might mean Redux hasn't updated yet, so retry check
          if (newItemsCount === 0) {
            // Retry once more after a longer delay to account for slow Redux updates
            setTimeout(() => {
              const retryCount = this.props.employeeLeaves?.length || 0;
              const retryNewItems = retryCount - previousCount;
              if (retryNewItems === 0) {
                // Still no new items after retry, no more data
                this.setState({ hasMore: false });
              } else if (retryNewItems < this.state.pageSize) {
                // Got fewer items than pageSize, so no more data
                this.setState({ hasMore: false });
              }
              // Update previousEmployeeCount for next load
              this.previousEmployeeCount = retryCount;
            }, 200);
          } else if (newItemsCount < this.state.pageSize) {
            // Got fewer items than pageSize, so no more data
            this.setState({ hasMore: false });
            // Update previousEmployeeCount for next load
            this.previousEmployeeCount = currentCount;
          } else {
            // Got a full page, might have more - hasMore stays true
            // Update previousEmployeeCount for next load
            this.previousEmployeeCount = currentCount;
            // Check if we're still near bottom and need to load more
            setTimeout(() => {
              this.checkAndLoadIfNearBottom();
            }, 100);
          }
        }, 150); // Small delay to ensure Redux state update
      }
    }).catch((error) => {
      this.setState({ isLoadingMore: false });
      // Don't set hasMore to false on error, might be a temporary issue
    });
  }

  checkAndLoadIfNearBottom = () => {
    // Check if we're near bottom and should load more
    // This is called after loading completes to handle continuous scrolling
    if (this.state.isLoadingMore || this.props.Loading) {
      return;
    }

    const container = this.scrollContainer || window;
    const isWindow = container === window;

    let scrollTop, scrollHeight, clientHeight;

    if (isWindow) {
      scrollTop = window.pageYOffset ||
        document.documentElement.scrollTop ||
        document.body.scrollTop ||
        0;
      scrollHeight = Math.max(
        document.documentElement.scrollHeight,
        document.body.scrollHeight
      );
      clientHeight = window.innerHeight ||
        document.documentElement.clientHeight ||
        0;
    } else {
      scrollTop = container.scrollTop || 0;
      scrollHeight = container.scrollHeight || 0;
      clientHeight = container.clientHeight || 0;
    }

    const distanceFromBottom = scrollHeight - (scrollTop + clientHeight);
    const isNearBottom = distanceFromBottom <= 800 && distanceFromBottom >= 0;
    const isAtTop = scrollTop <= 5;

    const hasMore = this.props.pagination?.hasNextPage !== undefined
      ? this.props.pagination.hasNextPage
      : this.state.hasMore;

    // Use same simplified logic as handleScroll
    if (isNearBottom && !isAtTop && hasMore === true) {
      this.loadMoreEmployees();
    }
  }


  updateTimeOffModalState(event) {
    let result = updateState(
      event,
      this.state.timeOffModal,
      this.state.timeOffModalErrors
    );
    this.setState({ timeOffModal: result });
  }

  /** Refetch wall chart via GetEmployeeCalendar (e.g. after cancel leave from modal). */
  refetchWallChartCalendar = () => {
    const currentViewDate = this.state.date
      ? moment(this.state.date).add(1, "days").toDate()
      : new Date();
    const filters = this.getCurrentFilterValues();
    this.props.timeOff.getEmployeeLeaves(
      currentViewDate,
      1,
      this.state.pageSize,
      false,
      null,
      filters.departmentIds,
      filters.accountType,
      filters.sortBy
    ).then((response) => {
      if (response?.pagination) {
        this.setState({
          hasMore: response.pagination.hasNextPage || false,
          currentPage: response.pagination.currentPage || 1,
          lastUpdate: Date.now(),
        });
      } else {
        this.setState({ lastUpdate: Date.now() });
      }
    }).catch(() => {
      this.setState({ lastUpdate: Date.now() });
    });
  };

  // Validation function with debouncing
  validateLeaveAvailability = (timeOffModal, hasUserMadeChanges = null) => {
    // Only validate if we have all required fields including LeaveTypeId
    if (!timeOffModal.StartDate || !timeOffModal.EndDate || !timeOffModal.EmployeeId || !timeOffModal.LeaveTypeId) {
      return;
    }

    // Check for invalid date range (end date before start date)
    const startDate = new Date(timeOffModal.StartDate);
    const endDate = new Date(timeOffModal.EndDate);
    if (endDate < startDate) {
      return;
    }

    // Use passed hasUserMadeChanges or fall back to state
    const userHasMadeChanges = hasUserMadeChanges !== null ? hasUserMadeChanges : this.state.hasUserMadeChanges;

    // In edit mode, only validate if user has made changes
    // This prevents showing validation messages for existing leave that hasn't been modified
    if (timeOffModal.IsEditMode && !userHasMadeChanges) {
      return;
    }

    // Clear any existing timeout
    if (this.validationTimeout) {
      clearTimeout(this.validationTimeout);
    }

    // Debounce validation calls to avoid too many API requests
    this.validationTimeout = setTimeout(() => {
      const validationData = {
        userId: timeOffModal.EmployeeId,
        startDate: timeOffModal.StartDate instanceof Date ? timeOffModal.StartDate.toISOString() : timeOffModal.StartDate,
        endDate: timeOffModal.EndDate instanceof Date ? timeOffModal.EndDate.toISOString() : timeOffModal.EndDate,
        startingLeave: timeOffModal.StartingLeave || 0,
        endingLeave: timeOffModal.EndingLeave || 0,
        leaveTypeId: timeOffModal.LeaveTypeId,
        isEdit: timeOffModal.IsEditMode || false,
        existingGroupId: timeOffModal.GroupId || null,
      };

      this.props.timeOff.validateLeaveAvailability(validationData);
    }, 300); // 300ms debounce
  };

  handleDateChange(name, date) {
    let result = updateDateState(
      name,
      date,
      this.state.timeOffModal,
      this.state.timeOffModalErrors
    );

    // Convert Date objects to ISO strings for serializable state
    if (result.StartDate instanceof Date) {
      result.StartDate = result.StartDate.toISOString();
    }
    if (result.EndDate instanceof Date) {
      result.EndDate = result.EndDate.toISOString();
    }

    // Update the timeOffModal with the new date and mark that user has made changes
    this.setState({
      timeOffModal: result,
      hasUserMadeChanges: true // Mark that user has made changes
    });

    // Get the updated timeOffModal state with ISO strings
    const updatedTimeOffModal = { ...this.state.timeOffModal, [name]: date instanceof Date ? date.toISOString() : date };

    // Check if both dates are selected
    if (updatedTimeOffModal.StartDate && updatedTimeOffModal.EndDate) {
      const startDate = new Date(updatedTimeOffModal.StartDate);
      const endDate = new Date(updatedTimeOffModal.EndDate);

      // Check if it's a single day or multi-day range
      const isSingleDay = startDate.toDateString() === endDate.toDateString();

      if (isSingleDay) {
        // Single Day Logic: Morning and Evening periods apply to the same day
        this.setState({
          timeOffModal: result,
          endingLeaveOptions: [
            {
              key: 0,
              text: "LunchTime",
              name: "LunchTime",
              value: 0,
            },
            {
              key: 1,
              text: "End of Day",
              name: "End of Day",
              value: 1,
            },
          ],
        });
        // Only validate if leave type is selected
        if (result.LeaveTypeId) {
          this.validateLeaveAvailability(result, true);
        }

        // If Morning is selected as Afternoon (1), automatically set Evening to End of Day (1)
        if (updatedTimeOffModal.StartingLeave === 1) {
          const updatedModal = { ...result, EndingLeave: 1 };
          this.setState({
            timeOffModal: updatedModal,
            endingLeaveOptions: [
              {
                key: 0,
                text: "End of Day",
                name: "End of Day",
                value: 1,
              },
            ],
          });
          // Only validate if leave type is selected
          if (updatedModal.LeaveTypeId) {
            this.validateLeaveAvailability(updatedModal, true);
          }
        }
      } else {
        // Multi-Day Range Logic: 
        // - Morning period applies to From Date (first day)
        // - Evening period applies to To Date (last day)
        // - Days in between are full days

        this.setState({
          timeOffModal: result,
          endingLeaveOptions: [
            {
              key: 0,
              text: "LunchTime",
              name: "LunchTime",
              value: 0,
            },
            {
              key: 1,
              text: "End of Day",
              name: "End of Day",
              value: 1,
            },
          ],
        });

        // Reset EndingLeave to default when switching to multi-day range
        // But preserve valid combinations
        let endingLeaveValue = 0; // Default to LunchTime
        if (result.StartingLeave === 1) {
          // If starting in afternoon, must end at end of day
          endingLeaveValue = 1;
        }
        const updatedModal = { ...result, EndingLeave: endingLeaveValue };
        this.setState({ timeOffModal: updatedModal });
        // Only validate if leave type is selected
        if (updatedModal.LeaveTypeId) {
          this.validateLeaveAvailability(updatedModal, true);
        }
      }
    }
  }

  updateDropDownState(event, data) {
    let timeOffDetail = this.state.timeOffModal;

    // Check if both dates are selected
    if (timeOffDetail.StartDate && timeOffDetail.EndDate) {
      const startDate = new Date(timeOffDetail.StartDate);
      const endDate = new Date(timeOffDetail.EndDate);
      const isSingleDay = startDate.toDateString() === endDate.toDateString();

      if (data.name === "StartingLeave") {
        if (isSingleDay) {
          // Single Day Logic
          if (
            (timeOffDetail.EndingLeave === 0 || timeOffDetail.EndingLeave === 1) &&
            data.value === 0 // Morning selected
          ) {
            // If Morning is selected, allow both LunchTime and End of Day for Evening
            timeOffDetail["StartingLeave"] = 0;
            timeOffDetail["EndingLeave"] = 0; // Reset to default
            this.setState({
              timeOffModal: timeOffDetail,
              endingLeaveOptions: [
                {
                  key: 0,
                  text: "LunchTime",
                  name: "LunchTime",
                  value: 0,
                },
                {
                  key: 1,
                  text: "End of Day",
                  name: "End of Day",
                  value: 1,
                },
              ],
            });
            // Validate leave availability after StartingLeave change
            this.validateLeaveAvailability(timeOffDetail, true);
            return;
          }

          if (data.value === 1) { // Afternoon selected
            // If Afternoon is selected, automatically set Evening to End of Day
            timeOffDetail["StartingLeave"] = 1;
            timeOffDetail["EndingLeave"] = 1;
            this.setState({
              timeOffModal: timeOffDetail,
              endingLeaveOptions: [
                {
                  key: 0,
                  text: "End of Day",
                  name: "End of Day",
                  value: 1,
                },
              ],
            });
            // Validate leave availability after StartingLeave change
            this.validateLeaveAvailability(timeOffDetail, true);
            return;
          }
        } else {
          // Multi-Day Range Logic
          // Morning period applies to From Date, Evening period applies to To Date
          // Both can be independently selected
          let result = updateDropDownState(
            event,
            data,
            this.state.timeOffModalErrors
          );
          timeOffDetail[data.name] = result;
          this.setState({
            timeOffModal: timeOffDetail,
            hasUserMadeChanges: true // Mark that user has made changes
          });
          // Validate leave availability after StartingLeave change (multi-day)
          this.validateLeaveAvailability(timeOffDetail);
          return;
        }
      }

      if (data.name === "EndingLeave") {
        if (isSingleDay) {
          // Single Day Logic: Evening period applies to the same day
          let result = updateDropDownState(
            event,
            data,
            this.state.timeOffModalErrors
          );
          timeOffDetail[data.name] = result;
          this.setState({
            timeOffModal: timeOffDetail,
            hasUserMadeChanges: true // Mark that user has made changes
          });
          // Validate leave availability after EndingLeave change (single day)
          this.validateLeaveAvailability(timeOffDetail);
          return;
        } else {
          // Multi-Day Range Logic: Evening period applies to To Date (last day)
          let result = updateDropDownState(
            event,
            data,
            this.state.timeOffModalErrors
          );
          timeOffDetail[data.name] = result;
          this.setState({
            timeOffModal: timeOffDetail,
            hasUserMadeChanges: true // Mark that user has made changes
          });
          // Validate leave availability after EndingLeave change (multi-day)
          this.validateLeaveAvailability(timeOffDetail);
          return;
        }
      }
    }

    // Default case for other fields
    let result = updateDropDownState(
      event,
      data,
      this.state.timeOffModalErrors
    );
    timeOffDetail[data.name] = result;
    this.setState({
      timeOffModal: timeOffDetail,
      hasUserMadeChanges: true // Mark that user has made changes
    });

    // Validate leave availability after dropdown changes
    this.validateLeaveAvailability(timeOffDetail, true);
  }

  bookTimeOff(event) {
    event.preventDefault();

    this.setState({ isFormLoading: true });

    // Check if it's edit mode
    const isEditMode = this.state.timeOffModal.IsEditMode || false;

    // Choose the appropriate action based on edit mode
    const action = isEditMode
      ? this.props.timeOff.updateLeave
      : this.props.timeOff.bookEmployeeTimeOff;

    action(this.state.timeOffModal, this.state.office.id)
      .then((response) => {
        if (response.success) {
          // Check for MaxAbsent errors in the response
          if (response.data && response.data.skippedDatesWithMessages) {
            showMaxAbsentErrors(response.data.skippedDatesWithMessages, "Some dates were skipped due to MaxAbsent limit");
          }

          // Show success message if there are booked dates
          if (response.data && response.data.bookedDates && response.data.bookedDates.length > 0) {
            const bookedCount = response.data.bookedDates.length;
            Common.showSuccessMessage(
              `Leave successfully booked for ${bookedCount} ${bookedCount === 1 ? 'date' : 'dates'}.`
            );
          }

          this.setState({ isModalOpen: false, isFormLoading: false });
          // Use the currently viewed month for fetching leaves
          // Match the date format used in other methods (add 1 day like handlePrevMonth/handleNextMonth)
          const currentViewDate = this.state.date
            ? moment(this.state.date).add(1, 'days').toDate()
            : moment().add(1, 'days').toDate();

          // Reset pagination state before fetching
          this.setState({ currentPage: 1, hasMore: true });

          // Fetch fresh employee leaves data
          const filters = this.getCurrentFilterValues();
          this.props.timeOff.getEmployeeLeaves(
            currentViewDate,
            1,
            this.state.pageSize,
            false,
            null, // departmentId (deprecated)
            filters.departmentIds,
            filters.accountType,
            filters.sortBy
          )
            .then((response) => {
              // Update hasMore based on pagination response
              if (response?.pagination) {
                this.setState({
                  hasMore: response.pagination.hasNextPage || false,
                  currentPage: response.pagination.currentPage || 1,
                  lastUpdate: Date.now() // Trigger re-render to ensure calendar updates
                });
              } else {
                // Even without pagination, update timestamp to ensure re-render
                this.setState({ lastUpdate: Date.now() });
              }
            })
            .catch((error) => {
              // Update timestamp even on error to ensure UI consistency
              this.setState({ lastUpdate: Date.now() });
            });
        } else {
          this.setState({ isFormLoading: false });
          Common.showErrorMessage(response.message);
        }
      })
      .catch((error) => {
        this.setState({ isFormLoading: false });
        Common.showErrorMessage(error);
      });
  }

  handlePrevMonth = (e) => {
    e.preventDefault();
    const newDate = this.state.date.clone().subtract(1, "months");
    this.setState({
      date: newDate,
      currentMonth: newDate.format("MMMM"),
      currentYear: newDate.format("YYYY"),
      currentPage: 1,
      hasMore: true,
    });

    let month = newDate.clone();
    let date = new Date(month._d);
    let selectedDate = moment(date).add(1, "days");
    const departmentId = this.state.selectedDepartmentId === "all" ? null : this.state.selectedDepartmentId;
    this.props.timeOff.getEmployeeLeaves(selectedDate._d, 1, this.state.pageSize, false, departmentId)
      .then((response) => {
        // Update hasMore based on pagination response
        if (response?.pagination) {
          const hasNextPage = response.pagination.hasNextPage === true;
          this.setState({ hasMore: hasNextPage });
        } else {
          // If no pagination info, check data length
          const dataLength = response?.data?.length || this.props.employeeLeaves?.length || 0;
          if (dataLength < this.state.pageSize) {
            this.setState({ hasMore: false });
          }
        }
      });
  };

  handleNextMonth = (e) => {
    e.preventDefault();
    const newDate = this.state.date.clone().add(1, "months");
    this.setState({
      date: newDate,
      currentMonth: newDate.format("MMMM"),
      currentYear: newDate.format("YYYY"),
      currentPage: 1,
      hasMore: true,
    });

    let month = newDate.clone();
    let date = new Date(month._d);
    let selectedDate = moment(date).add(1, "days");
    const filters = this.getCurrentFilterValues();
    this.props.timeOff.getEmployeeLeaves(
      selectedDate._d,
      1,
      this.state.pageSize,
      false,
      null, // departmentId (deprecated)
      filters.departmentIds,
      filters.accountType,
      filters.sortBy
    )
      .then((response) => {
        // Update hasMore based on pagination response
        if (response?.pagination) {
          const hasNextPage = response.pagination.hasNextPage === true;
          this.setState({ hasMore: hasNextPage });
        } else {
          // If no pagination info, check data length
          const dataLength = response?.data?.length || this.props.employeeLeaves?.length || 0;
          if (dataLength < this.state.pageSize) {
            this.setState({ hasMore: false });
          }
        }
      });
  };

  handleCloseModal = () => {
    // Reset modal state to initial values when closing
    this.setState({
      isModalOpen: false,
      timeOffModal: {
        StartDate: "",
        EndDate: "",
        LeaveNote: "",
        LeaveTypeId: null,
        StartingLeave: 0,
        EndingLeave: 0,
        EmployeeId: "",
        GroupId: null,
        IsEditMode: false,
        Approvals: null
      },
      timeOffModalErrors: {
        StartDate: "",
        EndDate: "",
        LeaveNote: "",
        LeaveTypeId: "",
      },
      hasUserMadeChanges: false,
      isLoadingLeaveTypes: false,
      // Reset period options to default
      startingLeaveOptions: this.props.startingLeave,
      endingLeaveOptions: this.props.endingLeave
    });

    // Clear validation results when closing modal
    this.props.timeOff.clearValidationResult();
  };

  handleBulkModalClose = () => {
    this.setState({
      isBulkModalOpen: false,
      bulkLeaveModal: {
        DepartmentId: null,
        LeaveTypeId: null,
        StartDate: "",
        EndDate: "",
        LeaveNote: "",
        StartingLeave: 0,
        EndingLeave: 0,
      },
    });
  };

  updateBulkLeaveModalState = (event) => {
    const { name, value } = event.target;
    this.setState({
      bulkLeaveModal: {
        ...this.state.bulkLeaveModal,
        [name]: value,
      },
    });
  };

  handleBulkDateChange = (field, date) => {
    if (date) {
      const updatedModal = {
        ...this.state.bulkLeaveModal,
        [field]: date.toISOString(),
      };
      this.setState({ bulkLeaveModal: updatedModal });
    }
  };

  updateBulkDropDownState = (event, data) => {
    const updatedModal = {
      ...this.state.bulkLeaveModal,
      [data.name]: data.value,
    };
    this.setState({ bulkLeaveModal: updatedModal });
  };

  bookBulkLeaves = (event) => {
    event.preventDefault();

    if (!this.state.bulkLeaveModal.DepartmentId || !this.state.bulkLeaveModal.LeaveTypeId) {
      Common.showErrorMessage("Please select both Department and Leave Type");
      return;
    }

    this.setState({ isFormLoading: true });

    this.props.timeOff.postBulkGroupLeaves(this.state.bulkLeaveModal)
      .then((response) => {
        this.setState({ isFormLoading: false });
        if (response.success) {
          // Check for MaxAbsent errors in the response
          if (response.data && response.data.skippedDatesWithMessages) {
            showMaxAbsentErrors(response.data.skippedDatesWithMessages, "Some dates were skipped due to MaxAbsent limit");
          }

          this.handleBulkModalClose();

          // Show success message, but also mention if some dates were skipped
          const hasSkippedDates = response.data && response.data.skippedDatesWithMessages &&
            Object.keys(response.data.skippedDatesWithMessages).length > 0;
          const message = hasSkippedDates
            ? (response.message || "Bulk leaves added, but some dates were skipped due to MaxAbsent limit")
            : (response.message || "Bulk leaves added successfully");
          Common.showSuccessMessage(message);

          // Refresh the employee leaves list
          const currentViewDate = this.state.date
            ? moment(this.state.date).add(1, 'days').toDate()
            : moment().add(1, 'days').toDate();

          this.setState({ currentPage: 1, hasMore: true });
          const filters = this.getCurrentFilterValues();
          this.props.timeOff.getEmployeeLeaves(
            currentViewDate,
            1,
            this.state.pageSize,
            false,
            null,
            filters.departmentIds,
            filters.accountType,
            filters.sortBy
          )
            .then((response) => {
              if (response?.pagination) {
                this.setState({
                  hasMore: response.pagination.hasNextPage || false,
                  currentPage: response.pagination.currentPage || 1,
                  lastUpdate: Date.now()
                });
              } else {
                this.setState({ lastUpdate: Date.now() });
              }
            })
            .catch((error) => {
              this.setState({ lastUpdate: Date.now() });
            });
        } else {
          Common.showErrorMessage(response.message || "Failed to add bulk leaves");
        }
      })
      .catch((error) => {
        this.setState({ isFormLoading: false });
        Common.showErrorMessage(error?.response?.data?.message || error?.message || "Failed to add bulk leaves");
      });
  };

  onClick = (date, employeeId, groupId = null) => {
    // Check if user has permission to view/edit this employee's leaves
    const employee = this.props.employeeLeaves?.find(emp => emp.userId === employeeId);
    if (employee && employee.isViewable === false) {
      Common.showErrorMessage("You don't have permission to view or edit this employee's leaves.");
      return;
    }

    // Check if this is an edit case (existing leave)
    if (groupId) {
      // This is an existing leave - load existing data for editing
      let localState = this.state.timeOffModal;
      localState["EmployeeId"] = employeeId;
      localState["GroupId"] = groupId; // Add group ID for edit mode
      localState["IsEditMode"] = true; // Flag for edit mode

      this.setState({
        timeOffModal: localState,
        isLoadingLeaveTypes: true,
        hasUserMadeChanges: false // Reset for edit mode - will be set to true when user makes changes
      });

      // Clear any previous validation results when opening in edit mode
      this.props.timeOff.clearValidationResult();

      // Load existing leave data and leave types
      Promise.all([
        this.props.timeOff.getLeaveByGroupId(groupId, employeeId),
        this.props.timeOff.getLeaveTypesByEmployee(employeeId)
      ])
        .then(([leaveData, leaveTypes]) => {

          // Populate the modal with existing leave data
          const updatedState = {
            ...localState,
            StartDate: leaveData.startDate ? new Date(leaveData.startDate).toISOString() : date._d.toISOString(),
            EndDate: leaveData.endDate ? new Date(leaveData.endDate).toISOString() : date._d.toISOString(),
            StartingLeave: leaveData.startingLeave || 0,
            EndingLeave: leaveData.endingLeave || 0,
            LeaveTypeId: leaveData.leaveTypeId || null,
            LeaveNote: leaveData.leaveNote || leaveData.leaveRequestComment?.leaveNote || "",
            // Additional fields from leaveData
            LeaveTypeName: leaveData.leaveTypeName || "",
            LeaveTypeColor: leaveData.leaveTypeColor || "",
            IsMultiDayRequest: leaveData.isMultiDayRequest || false,
            TotalDays: leaveData.totalDays || 1,
            UserName: leaveData.userName || "",
            CreatedBy: leaveData.createdBy || "",
            CreatedByName: leaveData.createdByName || "",
            CreatedDate: leaveData.createdDate || "",
            RequestDate: leaveData.requestDate || "",
            Approvals: leaveData.approvals || [],
            // Public holiday fields
            IsPublicHoliday: leaveData.isPublicHoliday || false,
            PublicHolidayName: leaveData.publicHolidayName || "",
            IsAutoDeducted: !!leaveData.isAutoDeducted,
            AutoDeductionReason: leaveData.autoDeductionReason ?? null,
          };

          // Set correct endingLeaveOptions based on the loaded data
          const startDate = new Date(leaveData.startDate);
          const endDate = new Date(leaveData.endDate);
          const isSingleDay = startDate.toDateString() === endDate.toDateString();

          let endingLeaveOptions = [];
          if (isSingleDay) {
            endingLeaveOptions = [
              { key: 0, text: "LunchTime", name: "LunchTime", value: 0 },
              { key: 1, text: "End of Day", name: "End of Day", value: 1 },
            ];
          } else {
            endingLeaveOptions = [
              { key: 0, text: "LunchTime", name: "LunchTime", value: 0 },
              { key: 1, text: "End of Day", name: "End of Day", value: 1 },
            ];
          }

          this.setState({
            timeOffModal: updatedState,
            isModalOpen: true,
            isLoadingLeaveTypes: false,
            endingLeaveOptions: endingLeaveOptions
          });

          // Don't validate immediately in edit mode - only when user makes changes
          // This prevents showing validation messages for existing leave that hasn't been modified
        })
        .catch((error) => {
          // Fallback: open modal with basic data
          const fallbackState = {
            ...localState,
            StartDate: date._d.toISOString(),
            EndDate: date._d.toISOString(),
          };
          this.setState({
            timeOffModal: fallbackState,
            isModalOpen: true,
            isLoadingLeaveTypes: false
          });
        });
    } else {
      // This is a new leave - handle add
      let localState = this.state.timeOffModal;
      localState["EmployeeId"] = employeeId;
      localState["StartDate"] = date._d.toISOString(); // Convert to ISO string
      localState["EndDate"] = date._d.toISOString(); // Convert to ISO string
      localState["GroupId"] = null; // No group ID for new leave
      localState["IsEditMode"] = false; // Flag for add mode
      localState["LeaveTypeId"] = null; // Reset leave type - user must select

      this.setState({
        timeOffModal: localState,
        isLoadingLeaveTypes: true,
        hasUserMadeChanges: false // Reset for new leave
      });

      // Clear any previous validation results when opening for new leave
      this.props.timeOff.clearValidationResult();

      // Fetch leave types for this specific employee first, then open modal
      this.props.timeOff.getLeaveTypesByEmployee(employeeId)
        .then(() => {
          // Open modal after leave types are loaded
          this.setState({
            isModalOpen: true,
            isLoadingLeaveTypes: false
          });
          // Don't validate if no leave type is selected - wait for user to select one
          // The validation will be triggered when user selects a leave type via updateDropDownState
        })
        .catch((error) => {
          // Still open modal even if leave types fail to load
          this.setState({
            isModalOpen: true,
            isLoadingLeaveTypes: false
          });
          // Don't validate if no leave type is selected
        });
    }
  };

  handleToday = (e) => {
    e.preventDefault();
    const today = moment().startOf('month');
    this.setState({
      date: today,
      currentMonth: today.format('MMMM'),
      currentYear: today.format('YYYY'),
      currentPage: 1,
      hasMore: true,
    });
    let selectedDate = moment(today).add(1, 'days');
    const filters = this.getCurrentFilterValues();
    this.props.timeOff.getEmployeeLeaves(
      selectedDate._d,
      1,
      this.state.pageSize,
      false,
      null, // departmentId (deprecated)
      filters.departmentIds,
      filters.accountType,
      filters.sortBy
    )
      .then((response) => {
        // Update hasMore based on pagination response
        if (response?.pagination) {
          const hasNextPage = response.pagination.hasNextPage === true;
          this.setState({ hasMore: hasNextPage });
        } else {
          // If no pagination info, check data length
          const dataLength = response?.data?.length || this.props.employeeLeaves?.length || 0;
          if (dataLength < this.state.pageSize) {
            this.setState({ hasMore: false });
          }
        }
      });
  };

  redirect = (id, name, imageUrl) => {
    let link = GetCompAndOffice();
    this.props.timeOff.clearMonthlyLeaves();
    const office = this.state.office || getSelectedOffice();
    // Navigate with employeeId, employee name, imageUrl, and current workplace/office so calendar opens in that context
    this.props.history.push({
      pathname: `${link}/dashboard/calender`,
      state: {
        employeeId: id,
        employeeName: name,
        employeeImageUrl: imageUrl,
        office: office || undefined
      }
    });
    // Fetch employee year leaves after navigation
    this.props.timeOff.getEmpYearLeaves(
      id,
      null,
      null,
      false
    );
  };

  handleDepartmentChange = (departmentId) => {
    this.setState({
      selectedDepartmentId: departmentId,
      currentPage: 1,
      hasMore: true,
      isDepartmentDropdownOpen: false
    });

    // Refetch data with new department filter
    const selectedDate = moment(this.state.date).add(1, 'days');
    const filters = this.getCurrentFilterValues();
    // Update departmentIds based on the selected department
    const departmentIds = departmentId === "all" ? null : [departmentId];
    this.props.timeOff.getEmployeeLeaves(
      selectedDate._d,
      1,
      this.state.pageSize,
      false,
      null, // departmentId (deprecated)
      departmentIds,
      filters.accountType,
      filters.sortBy
    )
      .then((response) => {
        // Update hasMore based on pagination response
        if (response?.pagination) {
          const hasNextPage = response.pagination.hasNextPage === true;
          this.setState({ hasMore: hasNextPage });
        } else {
          // If no pagination info, check data length
          const dataLength = response?.data?.length || this.props.employeeLeaves?.length || 0;
          if (dataLength < this.state.pageSize) {
            this.setState({ hasMore: false });
          } else if (dataLength === this.state.pageSize) {
            // Got exactly pageSize, might have more
            this.setState({ hasMore: true });
          }
        }
      })
      .catch((error) => {
        // Error handling - silently fail
      });
  }

  handleDepartmentChange = (departmentId) => {
    this.setState({
      selectedDepartmentId: departmentId,
      currentPage: 1,
      hasMore: true,
      isDepartmentDropdownOpen: false
    });

    // Refetch data with new department filter
    const selectedDate = moment(this.state.date).add(1, 'days');
    const filters = this.getCurrentFilterValues();
    // Update departmentIds based on the selected department
    const departmentIds = departmentId === "all" ? null : [departmentId];
    this.props.timeOff.getEmployeeLeaves(
      selectedDate._d,
      1,
      this.state.pageSize,
      false,
      null, // departmentId (deprecated)
      departmentIds,
      filters.accountType,
      filters.sortBy
    )
      .then((response) => {
        // Update hasMore based on pagination response
        if (response?.pagination) {
          const hasNextPage = response.pagination.hasNextPage === true;
          this.setState({ hasMore: hasNextPage });
        } else {
          // If no pagination info, check data length
          const dataLength = response?.data?.length || this.props.employeeLeaves?.length || 0;
          if (dataLength < this.state.pageSize) {
            this.setState({ hasMore: false });
          } else if (dataLength === this.state.pageSize) {
            // Got exactly pageSize, might have more
            this.setState({ hasMore: true });
          }
        }
      })
      .catch((error) => {
        // Error handling - silently fail
      });
  };

  // Helper method to check if current user is admin
  isCurrentUserAdmin = () => {
    let roleId = this.props.roleId || this.props.UserRoleId;
    if (!roleId) {
      try {
        const { WebStorage, WebStorageNames } = require("../../../utils");
        roleId = WebStorage.getLocalStore(WebStorageNames.RoleId);
      } catch (e) {
        roleId = localStorage.getItem("roleId");
      }
    }
    if (roleId) {
      roleId = parseInt(roleId);
      // Admin roles are typically 1 (Super Admin) or 2 (Admin)
      return roleId === 1 || roleId === 2;
    }
    return false;
  };

  getWallChartRoleDescriptionText = () => {
    const { t } = this.props;
    let roleId = this.props.roleId || this.props.UserRoleId;
    if (!roleId) {
      try {
        const { WebStorage, WebStorageNames } = require("../../../utils");
        roleId = WebStorage.getLocalStore(WebStorageNames.RoleId);
      } catch (e) {
        roleId = localStorage.getItem("roleId");
      }
    }
    roleId = parseInt(roleId, 10);
    if (roleId === 3) return t("app.wallChart.descriptionManager");
    if (roleId === 4) return t("app.wallChart.descriptionEmployee");
    return t("app.wallChart.descriptionAdmin");
  };

  renderWallChartHeaderDescription = () => {
    const { t } = this.props;
    const { office, company } = this.state;
    const propsCompany = this.props.company;

    let meta;
    if (office && office.name) {
      meta = (
        <span>
          <i className="bi bi-building me-1" />
          <strong style={{ color: "#1f2937" }}>{office.name}</strong>
          {(propsCompany && propsCompany.name) || (company && company.name) ? (
            <span>
              {" • "}
              <i className="bi bi-briefcase me-1" />
              {propsCompany?.name || company?.name || t("app.wallChart.company")}
            </span>
          ) : null}
        </span>
      );
    } else if (office) {
      meta = (
        <span>
          <i className="bi bi-hourglass-split me-1" />
          {t("app.wallChart.loadingWorkplace")}
        </span>
      );
    } else {
      meta = (
        <span>
          <i className="bi bi-info-circle me-1" />
          {t("app.wallChart.workplaceNotAvailable")}
        </span>
      );
    }

    return (
      <>
        <span className="d-block mb-2" style={{ fontSize: "13px", color: "#6b7280" }}>
          {meta}
        </span>
        <span>{this.getWallChartRoleDescriptionText()}</span>
      </>
    );
  };

  // Count active filters
  getActiveFilterCount = () => {
    let count = 0;
    if (this.state.filterSortBy !== "firstName") count++;
    if (this.state.filterAccountType !== "all") count++;
    if (this.state.selectedDepartments.length > 0 && !this.state.selectedDepartments.includes("all")) count++;
    return count;
  }

  // Handle department selection in filter modal (supports multiple)
  handleDepartmentToggle = (departmentId) => {
    const { selectedDepartments } = this.state;
    if (departmentId === "all") {
      // Toggle "All Departments"
      if (selectedDepartments.includes("all")) {
        this.setState({ selectedDepartments: [] });
      } else {
        this.setState({ selectedDepartments: ["all"] });
      }
    } else {
      // Toggle specific department
      const newSelection = selectedDepartments.includes(departmentId)
        ? selectedDepartments.filter(id => id !== departmentId)
        : [...selectedDepartments.filter(id => id !== "all"), departmentId];
      this.setState({ selectedDepartments: newSelection });
    }
  }

  // Apply filters from modal
  applyFilters = () => {
    // Get selected departments (excluding "all")
    const selectedDeptIds = this.state.selectedDepartments.filter(id => id !== "all");

    // For backward compatibility, also set selectedDepartmentId
    const departmentId = selectedDeptIds.length > 0
      ? selectedDeptIds[0]
      : "all";

    this.setState({
      selectedDepartmentId: departmentId,
      showFilterModal: false,
      currentPage: 1,
      hasMore: true
    });

    // Refetch data with new filters
    const selectedDate = moment(this.state.date).add(1, 'days');
    const departmentIds = selectedDeptIds.length > 0 ? selectedDeptIds : null;
    // Get the actual filter values from state - don't use || operator as it will use "all" for falsy values
    const accountType = this.state.filterAccountType !== undefined && this.state.filterAccountType !== null
      ? this.state.filterAccountType
      : "all";
    const sortBy = this.state.filterSortBy !== undefined && this.state.filterSortBy !== null
      ? this.state.filterSortBy
      : "firstName";

    // Debug: Log what we're sending
    console.log('=== Apply Filters ===');
    console.log('State filterAccountType:', this.state.filterAccountType);
    console.log('State filterSortBy:', this.state.filterSortBy);
    console.log('Computed accountType:', accountType);
    console.log('Computed sortBy:', sortBy);

    this.props.timeOff.clearMonthlyLeaves();
    this.props.timeOff.getEmployeeLeaves(
      selectedDate._d,
      1,
      this.state.pageSize,
      false,
      null, // departmentId (deprecated, use departmentIds instead)
      departmentIds, // departmentIds array
      accountType,
      sortBy
    )
      .then((response) => {
        if (response?.pagination) {
          const hasNextPage = response.pagination.hasNextPage === true;
          this.setState({ hasMore: hasNextPage });
        } else {
          const dataLength = response?.data?.length || this.props.employeeLeaves?.length || 0;
          if (dataLength < this.state.pageSize) {
            this.setState({ hasMore: false });
          } else if (dataLength === this.state.pageSize) {
            this.setState({ hasMore: true });
          }
        }
      })
      .catch((error) => {
        // Error handling
      });
  }

  // Clear all filters
  clearFilters = () => {
    this.setState({
      filterSortBy: "firstName", // Maps to "name" in backend
      filterAccountType: "all",
      selectedDepartments: ["all"],
      selectedDepartmentId: "all",
      currentPage: 1,
      hasMore: true
    });

    // Refetch data without filters (using defaults)
    const selectedDate = moment(this.state.date).add(1, 'days');
    this.props.timeOff.clearMonthlyLeaves();
    this.props.timeOff.getEmployeeLeaves(
      selectedDate._d,
      1,
      this.state.pageSize,
      false,
      null, // departmentId
      null, // departmentIds
      "all", // accountType
      "firstName" // sortBy (maps to "name" in backend)
    )
      .then((response) => {
        if (response?.pagination) {
          const hasNextPage = response.pagination.hasNextPage === true;
          this.setState({ hasMore: hasNextPage });
        } else {
          const dataLength = response?.data?.length || this.props.employeeLeaves?.length || 0;
          if (dataLength < this.state.pageSize) {
            this.setState({ hasMore: false });
          } else if (dataLength === this.state.pageSize) {
            this.setState({ hasMore: true });
          }
        }
      })
      .catch((error) => {
        // Error handling
      });
  }

  handleGroupLeaveClick = () => {
    // Open bulk modal for department-based leave addition
    const today = new Date();
    const bulkLeaveModal = {
      DepartmentId: null,
      LeaveTypeId: null,
      StartDate: today.toISOString(),
      EndDate: today.toISOString(),
      LeaveNote: "",
      StartingLeave: 0,
      EndingLeave: 0,
    };

    this.setState({
      isBulkModalOpen: true,
      bulkLeaveModal: bulkLeaveModal,
      isLoadingBulkLeaveTypes: true,
      isLoadingBulkDepartments: false,
      endingLeaveOptions: [
        {
          key: 0,
          text: "LunchTime",
          name: "LunchTime",
          value: 0,
        },
        {
          key: 1,
          text: "End of Day",
          name: "End of Day",
          value: 1,
        },
      ],
      startingLeaveOptions: [
        {
          key: 0,
          text: "Morning",
          name: "Morning",
          value: 0,
        },
        {
          key: 1,
          text: "Afternoon",
          name: "Afternoon",
          value: 1,
        },
      ],
    });

    // Fetch company leave types
    this.fetchCompanyLeaveTypes();

    // Ensure departments are loaded
    if (!this.props.departments || (Array.isArray(this.props.departments) && this.props.departments.length === 0)) {
      // this.props.dispatch(onGetDepartments(true)); // Old endpoint - commented out
      this.fetchUserDepartments(); // Using new UserDepartments endpoint
    }
  };

  fetchCompanyLeaveTypes = () => {
    axiosBasic
      .get(config.REST_API.LeaveType.GetActiveLeaveTypes)
      .then((response) => {
        const { success, data } = response.data;
        if (success && data) {
          // Map leave types to dropdown format
          const leaveTypeOptions = data
            .filter(lt => lt.active !== false) // Only active leave types
            .map((option) => {
              let deducted = true;
              if (option.deducted !== undefined && option.deducted !== null) {
                deducted = option.deducted === true || option.deducted === 'true' || option.deducted === 1 || option.deducted === '1';
              }
              return {
                key: option.id,
                text: option.name,
                name: option.name,
                value: option.id,
                deducted: deducted,
              };
            });

          this.setState({
            companyLeaveTypes: leaveTypeOptions,
            isLoadingBulkLeaveTypes: false,
          });
        } else {
          this.setState({
            companyLeaveTypes: [],
            isLoadingBulkLeaveTypes: false,
          });
        }
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("employeesCalendarCompanyLeaveTypes", {
            type: "exception",
            success: false,
            reason: error?.response?.data?.message ?? error?.message ?? "Failed to load leave types",
            status: error?.response?.status,
          });
        }
        Common.showErrorMessage(error?.response?.data?.message || "Failed to load leave types");
        this.setState({
          companyLeaveTypes: [],
          isLoadingBulkLeaveTypes: false,
        });
      });
  };

  handleFavoriteToggle = (e, employeeId) => {
    e.preventDefault();
    e.stopPropagation();

    console.log('Favorite toggle clicked for employee:', employeeId);

    // Set loading state for favorite update
    this.setState({ isUpdatingFavorite: true });

    // Store current scroll position and page before refreshing
    const currentPage = this.state.currentPage;
    const container = this.scrollContainer || window;
    const isWindow = container === window;
    const currentScrollTop = isWindow
      ? window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop || 0
      : container.scrollTop || 0;

    // Optimistically update the UI by finding and updating the employee in the list
    // Note: This is a local state update - the actual data will be refreshed from the server
    // when the component re-renders or when getEmployeeLeaves is called again

    this.props.timeOff.upsertFavorite(employeeId)
      .then((response) => {
        console.log('Favorite toggle response:', response);
        if (response && response.success) {
          // Refresh the employee list to get updated favorite status, but maintain current page
          const selectedDate = moment(this.state.date).add(1, 'days');
          const filters = this.getCurrentFilterValues();

          // Load all pages up to the current page to maintain the user's view
          // First, clear existing data and load from page 1
          this.props.timeOff.getEmployeeLeaves(
            selectedDate._d,
            1,
            this.state.pageSize,
            false,
            null, // departmentId (deprecated)
            filters.departmentIds,
            filters.accountType,
            filters.sortBy
          )
            .then((firstPageResponse) => {
              if (currentPage > 1) {
                // If user was on a later page, load all pages up to current page
                const loadPagesPromises = [];
                for (let page = 2; page <= currentPage; page++) {
                  loadPagesPromises.push(
                    this.props.timeOff.getEmployeeLeaves(
                      selectedDate._d,
                      page,
                      this.state.pageSize,
                      true,
                      null, // departmentId (deprecated)
                      filters.departmentIds,
                      filters.accountType,
                      filters.sortBy
                    )
                  );
                }

                Promise.all(loadPagesPromises)
                  .then(() => {
                    // After loading all pages, update state and restore scroll position
                    setTimeout(() => {
                      if (isWindow) {
                        window.scrollTo(0, currentScrollTop);
                      } else {
                        container.scrollTop = currentScrollTop;
                      }
                      this.setState({
                        isUpdatingFavorite: false,
                        lastUpdate: Date.now()
                      });
                    }, 100);
                  })
                  .catch((error) => {
                    this.setState({ isUpdatingFavorite: false });
                  });
              } else {
                // User was on page 1, just update state
                if (firstPageResponse?.pagination) {
                  this.setState({
                    hasMore: firstPageResponse.pagination.hasNextPage || false,
                    currentPage: firstPageResponse.pagination.currentPage || 1,
                    lastUpdate: Date.now(),
                    isUpdatingFavorite: false
                  });
                } else {
                  this.setState({ isUpdatingFavorite: false });
                }
              }
            })
            .catch((error) => {
              this.setState({ isUpdatingFavorite: false });
            });
        } else {
          this.setState({ isUpdatingFavorite: false });
        }
      })
      .catch((error) => {
        if (typeof posthog !== "undefined" && posthog.capture) {
          posthog.capture("employeesCalendarFavoriteToggle", {
            type: "exception",
            success: false,
            reason: error?.response?.data?.message ?? error?.message ?? "Favorite toggle error",
            status: error?.response?.status,
          });
        }
        this.setState({ isUpdatingFavorite: false });
        // Error is already handled in the action
      });
  };

  renderEmployee(employees) {
    let employeeRows = [];
    if (employees && employees.length > 0) {
      // Filter and map employees
      // Note: Department filtering is now handled by the backend API
      employeeRows = employees
        .filter((emp) => {
          // Only show active employees - skip if explicitly set to false
          // If active property doesn't exist or is true/undefined, show the employee
          if (emp && (emp.active === false || emp.isActive === false)) {
            return false;
          }
          return emp != null; // Filter out null/undefined
        })
        .map((emp) => {
          // Sort totalLeavesRemaining by leaveTypeId before rendering and filter by deducted property
          const sortedLeavesRemaining = emp.totalLeavesRemaining
            ? [...emp.totalLeavesRemaining]
              .filter((leave) => leave.deducted === true)
              .sort((a, b) => (a.leaveTypeId || 0) - (b.leaveTypeId || 0))
            : [];

          // Get current user info to check if this is the current user
          const currentUserInfo = getUserInfo();
          const currentUserId = currentUserInfo?.selfUserId;
          const isCurrentUser = currentUserId && emp.userId && currentUserId.toString() === emp.userId.toString();

          return (
            <Table.Row key={emp.id}>
              <Table.Cell
                className="timeOffUser employee-cell-hover"
                style={{ paddingTop: '1%', width: '22%' }}
              >
                <div className="employee-row-content" style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
                  {/* Star Icon - Visible on hover or when favorited, but not for current user */}
                  {!isCurrentUser ? (
                    <div
                      onClick={(e) => {
                        e.preventDefault();
                        e.stopPropagation();
                        this.handleFavoriteToggle(e, emp.userId);
                      }}
                      onMouseDown={(e) => {
                        e.stopPropagation();
                      }}
                      style={{

                        marginLeft: '-20px',
                        paddingRight: '7%',
                        cursor: 'pointer',
                      }}
                      title={emp.isFavorite ? 'Remove from favorites' : 'Add to favorites'}
                    >
                      <i
                        className={`bi ${emp.isFavorite ? 'bi-star-fill' : 'bi-star'} employee-star-icon ${emp.isFavorite ? 'favorite-star' : ''}`}
                        style={{
                          fontSize: '18px',
                          color: emp.isFavorite ? '#ffc107' : '#6c757d',
                          opacity: emp.isFavorite ? 1 : 0,
                          transition: 'opacity 0.2s ease, color 0.2s ease',
                          pointerEvents: 'none'
                        }}
                      ></i>
                    </div>
                  ) : (
                    <div
                      style={{
                        paddingRight: '18px',
                      }}
                    ></div>
                  )}

                  <span
                    className="userPicture position-relative employee-hover-target"
                    onClick={emp.isClickable !== false ? () => this.redirect(emp.userId, emp.name, emp.imageUrl) : undefined}
                    style={{ cursor: emp.isClickable !== false ? 'pointer' : 'default',marginLeft: '5px' }}
                  >
                    {emp.imageUrl !== null && emp.imageUrl !== "" ? (
                      <Popup
                        trigger={
                          <img src={emp.imageUrl} alt="" />
                        }
                        content={
                          <img
                            src={emp.imageUrl}
                            alt=""
                            style={{ width: 120, height: 120, objectFit: "cover", borderRadius: "50%", display: "block" }}
                          />
                        }
                        on="hover"
                        hoverable
                        position="top left"
                      />
                    ) : (
                      <img src="/assets/img/blank.png" alt="" />
                    )}
                    {sortedLeavesRemaining && sortedLeavesRemaining.length > 0 && emp.isViewable !== false ? (
                      sortedLeavesRemaining.length === 1 ? (
                        <div
                          className="leaveBadge"
                          title={`${sortedLeavesRemaining[0].leaveTypeName || 'Leave'}: ${sortedLeavesRemaining[0].remainingLeaves} remaining (${sortedLeavesRemaining[0].totalUserLeavesInDays || 0} days / ${sortedLeavesRemaining[0].totalUserLeavesInHours || 0} hours)`}
                        >
                          {sortedLeavesRemaining[0].remainingLeaves}
                        </div>
                      ) : (
                        <>
                          {sortedLeavesRemaining.slice(0, 3).map((leave, index) => (
                            <div
                              key={index}
                              className={`leaveBadgesContainer leaveBadgeMultiple icon-${index} ${index === 0 ? 'primary' : index === 1 ? 'secondary' : 'success'}`}
                              title={`${leave.leaveTypeName || 'Leave'}: ${leave.remainingLeaves} remaining (${leave.totalUserLeavesInDays || 0} days / ${leave.totalUserLeavesInHours || 0} hours)`}
                            >
                              {leave.remainingLeaves}
                            </div>
                          ))}

                        </>
                      )
                    ) : null}
                  </span>
                  <div
                    className={`employee-name-container employee-hover-target ${emp.isClickable !== false ? 'employee-name-clickable' : ''}`}
                    onClick={emp.isClickable !== false ? () => this.redirect(emp.userId, emp.name, emp.imageUrl) : undefined}
                    style={{ cursor: emp.isClickable !== false ? 'pointer' : 'default', flex: 1, marginRight: '-30px' }}
                  >
                    <span
                      className={emp.isClickable !== false ? "employee-name employee-name-clickable" : "employee-name"}
                      title={emp.name}
                      style={{ paddingLeft: '3%' }}
                    >
                      {emp.name && emp.name.length > 20 ? `${emp.name.substring(0, 20)}...` : emp.name}
                    </span>
                    {emp.designation && (
                      <span
                        className="employee-designation employee-hover-target"
                        title={emp.designation}
                        style={{ cursor: 'default', paddingLeft: '3%' }}
                        onClick={(e) => e.stopPropagation()}
                      >
                        {emp.designation.length > 28 ? `${emp.designation.substring(0, 28)}...` : emp.designation}
                      </span>
                    )}
                  </div>
                </div>
              </Table.Cell>
              <Table.Cell>
                <WallChart
                  weekNumbers
                  startDate={this.state.date}
                  endDate={this.state.date.clone().endOf("month")}
                  EmployeeLeaves={emp.userLeaves}
                  onClick={this.onClick}
                  EmployeeId={emp.userId}
                  PublicHolidays={emp.publicHolidays}
                  officeBusinessDays={this.state.office?.id ? (this.props.officeBusinessDays[this.state.office.id]?.businessDays || 62) : 62}
                  isEmployeeViewable={emp.isViewable}
                />
              </Table.Cell>
            </Table.Row>
          );
        });
    }

    // Add "New User" row if user is admin and (scrolling is finished or there are no employees)
    if (this.isCurrentUserAdmin() && (!this.state.hasMore || employeeRows.length === 0) && !this.state.isLoadingMore) {
      employeeRows.push(
        <Table.Row key="new-user-row" className="new-user-row">
          <Table.Cell
            className="timeOffUser"
            style={{ paddingTop: '1%' }}
          >
            <div className="employee-row-content" style={{ display: 'flex', alignItems: 'center', position: 'relative' }}>
              {/* Placeholder for star icon alignment */}
              <div style={{ width: '14px' }}></div>

              <span
                className="userPicture position-relative new-user-avatar"
                onClick={() => {
                  this.props.history.push(`/dashboard/user-form`);
                }}
                style={{
                  cursor: 'pointer',
                  background: '#e9ecef',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center'
                }}
              >
                <i className="bi bi-plus-lg" style={{ fontSize: '20px', color: '#6c757d' }}></i>
              </span>
              <div
                className="employee-name-container"
                onClick={() => {
                  this.props.history.push(`/dashboard/user-form`);
                }}
                style={{ cursor: 'pointer', flex: 1 }}
              >
                <span
                  className="employee-name employee-name-clickable"
                  style={{ color: '#0d6efd', textDecoration: 'underline', paddingLeft: '3%' }}
                >
                  New user
                </span>
                <span
                  className="employee-designation"
                  style={{ cursor: 'default', color: '#6c757d', paddingLeft: '3%' }}
                >
                  Add someone else
                </span>
              </div>
            </div>
          </Table.Cell>
          <Table.Cell>
            {/* Empty cell for calendar alignment */}
          </Table.Cell>
        </Table.Row>
      );
    }

    return employeeRows.length > 0 ? employeeRows : null;
  }

  render() {
    const { currentMonth, currentYear } = this.state;
    // Map leave types and preserve icon and deducted properties
    let allLeaveTypes = this.props.leaveTypes?.map(function (option) {
      // Handle deducted property - convert to boolean and default to true (deductible)
      let deducted = true; // Default to deductible
      if (option.deducted !== undefined && option.deducted !== null) {
        // Handle boolean, string, or number values
        deducted = option.deducted === true || option.deducted === 'true' || option.deducted === 1 || option.deducted === '1';
      }

      return {
        key: option.id,
        text: option.name,
        name: option.name,
        value: option.id,
        leavesCount: option.leavesCount || 0,
        leaveDivision: option.leaveDivision === 0 ? "Days" : "Hours",
        icon: option.icon || null,
        deducted: deducted,
      };
    }) || [];

    // Separate deductible and non-deductible leaves (deducted === true means deductible)
    const deductibleLeaves = allLeaveTypes.filter(lt => lt.deducted === true);
    const nonDeductibleLeaves = allLeaveTypes.filter(lt => lt.deducted === false);

    // Sort each group
    deductibleLeaves.sort((a, b) => a.key - b.key);
    nonDeductibleLeaves.sort((a, b) => a.key - b.key);

    // Create grouped options: deductible header + leaves, then non-deductible header + leaves
    let leaveTypeOptions = [];

    // Add header separator for deductible leaves if they exist
    if (deductibleLeaves.length > 0) {
      leaveTypeOptions.push({
        key: 'deductible-header',
        text: 'Deductible',
        value: 'deductible-header',
        disabled: true,
        className: 'leave-type-header',
        isHeader: true
      });
      leaveTypeOptions.push(...deductibleLeaves);
    }

    // Add header separator for non-deductible leaves if they exist
    if (nonDeductibleLeaves.length > 0) {
      leaveTypeOptions.push({
        key: 'non-deductible-header',
        text: 'Non-Deductible',
        value: 'non-deductible-header',
        disabled: true,
        className: 'leave-type-header',
        isHeader: true
      });
      leaveTypeOptions.push(...nonDeductibleLeaves);
    }

    // If subscription is suspended, show restriction message
    if (this.state.isSubscriptionSuspended) {
      return (
        <div style={{ padding: "20px" }}>
          <SubscriptionRestriction actionKey="app.subscriptionRestriction.actionAccessWallChart" />
        </div>
      );
    }

    return (
      <Container className="py-4 px-3 px-md-4" fluid>
        <TImeOffModal
          IsModalOpen={this.state.isModalOpen}
          handleCloseModal={this.handleCloseModal}
          onChange={this.updateTimeOffModalState}
          handleDateChange={this.handleDateChange}
          onSave={this.bookTimeOff}
          onCancelLeaveSuccess={this.refetchWallChartCalendar}
          isFormLoading={this.state.isFormLoading}
          startingLeaveOptions={this.state.startingLeaveOptions}
          endingLeaveOptions={this.state.endingLeaveOptions}
          timeOffModal={this.state.timeOffModal}
          updateDropDown={this.updateDropDownState}
          leaveTypeOptions={leaveTypeOptions}
          isLoadingLeaveTypes={this.state.isLoadingLeaveTypes}
          isEditMode={this.state.timeOffModal.IsEditMode || false}
          validation={this.props.validation}
          validateLeaveAvailability={this.validateLeaveAvailability}
          isAdmin={this.isCurrentUserAdmin()}
        />

        {/* Bulk Group Leave Modal */}
        {(() => {
          // Prepare department options
          let departmentOptions = [];
          if (this.props.departments) {
            if (Array.isArray(this.props.departments)) {
              // If it's a flat array
              departmentOptions = this.props.departments.map(dept => ({
                key: dept.id || dept.value,
                text: dept.name || dept.text,
                value: dept.id || dept.value,
              }));
            } else if (this.props.departments.lookups && Array.isArray(this.props.departments.lookups)) {
              // If it's nested in lookups
              departmentOptions = this.props.departments.lookups.map(dept => ({
                key: dept.id || dept.value,
                text: dept.name || dept.text,
                value: dept.id || dept.value,
              }));
            } else if (this.props.departments[0] && Array.isArray(this.props.departments[0])) {
              // If it's nested in first array element
              departmentOptions = this.props.departments[0].map(dept => ({
                key: dept.id || dept.value,
                text: dept.name || dept.text,
                value: dept.id || dept.value,
              }));
            }
          }

          return (
            <BulkGroupLeaveModal
              t={this.props.t}
              IsModalOpen={this.state.isBulkModalOpen}
              handleCloseModal={this.handleBulkModalClose}
              onChange={this.updateBulkLeaveModalState}
              handleDateChange={this.handleBulkDateChange}
              onSave={this.bookBulkLeaves}
              bulkLeaveModal={this.state.bulkLeaveModal}
              updateDropDown={this.updateBulkDropDownState}
              isFormLoading={this.state.isFormLoading}
              leaveTypeOptions={this.state.companyLeaveTypes}
              departmentOptions={departmentOptions}
              startingLeaveOptions={this.state.startingLeaveOptions}
              endingLeaveOptions={this.state.endingLeaveOptions}
              isLoadingLeaveTypes={this.state.isLoadingBulkLeaveTypes}
              isLoadingDepartments={this.state.isLoadingBulkDepartments}
            />
          );
        })()}

        {/* Filter Modal - content scrolls when height increases */}
        <Modal
          open={this.state.showFilterModal}
          onClose={() => this.setState({ showFilterModal: false })}
          size="small"
          className="filter-modal"
          style={{
            borderRadius: '16px',
            overflow: 'hidden',
            border: 'none',
            maxHeight: '90vh',
            display: 'flex',
            flexDirection: 'column'
          }}
        >
          <Modal.Header
            className="filter-modal-header"
            style={{
              margin: 0,
              border: 'none'
            }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '12px', position: 'relative', zIndex: 2 }}>
              <span style={{ fontSize: '1.5rem', fontWeight: '700', color: '#ffffff', textShadow: '0 1px 2px rgba(0,0,0,0.1)' }}>{this.props.t("app.wallChart.filter")}</span>
              {this.getActiveFilterCount() > 0 && (
                <span style={{
                  background: 'rgba(255,255,255,0.25)',
                  color: 'white',
                  borderRadius: '50%',
                  width: '24px',
                  height: '24px',
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  fontSize: '12px',
                  fontWeight: '600',
                  backdropFilter: 'blur(10px)'
                }}>
                  {this.getActiveFilterCount()}
                </span>
              )}
              <span style={{ fontSize: '0.875rem', color: 'rgba(255,255,255,0.9)', marginLeft: '8px' }}>
                {this.props.t("app.wallChart.filterModalUsersCount", { count: this.props.pagination?.totalCount || 0 })}
              </span>
            </div>
            <button
              onClick={this.clearFilters}
              style={{
                background: this.getActiveFilterCount() > 0 ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.15)',
                border: '1px solid rgba(255,255,255,0.3)',
                color: 'white',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer',
                padding: '6px 12px',
                borderRadius: '8px',
                backdropFilter: 'blur(10px)',
                transition: 'all 0.2s ease',
                position: 'relative',
                zIndex: 2,
                opacity: this.getActiveFilterCount() > 0 ? 1 : 0.7
              }}
              onMouseEnter={(e) => {
                e.target.style.background = 'rgba(255,255,255,0.3)';
                e.target.style.borderColor = 'rgba(255,255,255,0.4)';
                e.target.style.opacity = '1';
              }}
              onMouseLeave={(e) => {
                e.target.style.background = this.getActiveFilterCount() > 0 ? 'rgba(255,255,255,0.2)' : 'rgba(255,255,255,0.15)';
                e.target.style.borderColor = 'rgba(255,255,255,0.3)';
                e.target.style.opacity = this.getActiveFilterCount() > 0 ? '1' : '0.7';
              }}
              title={this.props.t("app.wallChart.clearAllFilters")}
            >
              {this.props.t("app.wallChart.clearFilter")}
            </button>
          </Modal.Header>
          <Modal.Content style={{
            padding: '20px',
            margin: 0,
            flex: '1 1 auto',
            minHeight: 0,
            maxHeight: '60vh',
            overflowY: 'auto',
            borderRadius: 0,
            WebkitOverflowScrolling: 'touch'
          }}>
            {/* Users Section */}
            <div style={{ marginBottom: '24px' }}>
              <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', color: '#212529' }}>
                {this.props.t("app.wallChart.filterSectionUsers")}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="sortBy"
                    value="firstName"
                    checked={this.state.filterSortBy === "firstName"}
                    onChange={(e) => this.setState({ filterSortBy: e.target.value })}
                    style={{ cursor: 'pointer' }}
                  />
                  <span style={{ fontSize: '14px', color: '#212529' }}>{this.props.t("app.wallChart.sortByFirstName")}</span>
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="sortBy"
                    value="lastName"
                    checked={this.state.filterSortBy === "lastName"}
                    onChange={(e) => this.setState({ filterSortBy: e.target.value })}
                    style={{ cursor: 'pointer' }}
                  />
                  <span style={{ fontSize: '14px', color: '#212529' }}>{this.props.t("app.wallChart.sortByLastName")}</span>
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="sortBy"
                    value="department"
                    checked={this.state.filterSortBy === "department"}
                    onChange={(e) => this.setState({ filterSortBy: e.target.value })}
                    style={{ cursor: 'pointer' }}
                  />
                  <span style={{ fontSize: '14px', color: '#212529' }}>{this.props.t("app.wallChart.sortByDepartment")}</span>
                </label>
              </div>
            </div>

            {/* Account type Section */}
            <div style={{ marginBottom: '24px' }}>
              <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', color: '#212529' }}>
                {this.props.t("app.wallChart.accountType")}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="accountType"
                    value="all"
                    checked={this.state.filterAccountType === "all"}
                    onChange={(e) => this.setState({ filterAccountType: e.target.value })}
                    style={{ cursor: 'pointer' }}
                  />
                  <span style={{ fontSize: '14px', color: '#212529' }}>{this.props.t("app.wallChart.allAccounts")}</span>
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="accountType"
                    value="departmentManagers"
                    checked={this.state.filterAccountType === "departmentManagers"}
                    onChange={(e) => this.setState({ filterAccountType: e.target.value })}
                    style={{ cursor: 'pointer' }}
                  />
                  <span style={{ fontSize: '14px', color: '#212529' }}>{this.props.t("app.wallChart.managers")}</span>
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="accountType"
                    value="usersIApprove"
                    checked={this.state.filterAccountType === "usersIApprove"}
                    onChange={(e) => this.setState({ filterAccountType: e.target.value })}
                    style={{ cursor: 'pointer' }}
                  />
                  <span style={{ fontSize: '14px', color: '#212529' }}>{this.props.t("app.wallChart.usersIApprove")}</span>
                </label>
                <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                  <input
                    type="radio"
                    name="accountType"
                    value="myFavourites"
                    checked={this.state.filterAccountType === "myFavourites"}
                    onChange={(e) => this.setState({ filterAccountType: e.target.value })}
                    style={{ cursor: 'pointer' }}
                  />
                  <span style={{ fontSize: '14px', color: '#212529' }}>{this.props.t("app.wallChart.myFavourites")}</span>
                </label>
              </div>
            </div>

            {/* Departments Section */}
            <div>
              <div style={{ fontSize: '16px', fontWeight: '600', marginBottom: '12px', color: '#212529' }}>
                {this.props.t("app.wallChart.filterSectionDepartments")}
              </div>
              <div style={{ display: 'flex', flexDirection: 'column', gap: '12px', maxHeight: '200px', overflowY: 'auto' }}>
                <label style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}>
                  <input
                    type="checkbox"
                    checked={this.state.selectedDepartments.includes("all")}
                    onChange={() => this.handleDepartmentToggle("all")}
                    style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                  />
                  <span style={{ fontSize: '14px', color: '#212529' }}>{this.props.t("app.wallChart.allDepartments")}</span>
                </label>
                {(() => {
                  // Handle departments data structure (reducer stores flat array from payload[0])
                  let departments = [];
                  if (this.props.departments) {
                    if (Array.isArray(this.props.departments)) {
                      departments = this.props.departments;
                    } else if (this.props.departments.lookups && Array.isArray(this.props.departments.lookups)) {
                      departments = this.props.departments.lookups;
                    } else if (this.props.departments[0] && Array.isArray(this.props.departments[0])) {
                      departments = this.props.departments[0];
                    }
                  }

                  if (!departments || departments.length === 0) {
                    return (
                      <div style={{ fontSize: '14px', color: '#6c757d', fontStyle: 'italic', paddingLeft: '28px' }}>
                        {this.props.t("app.wallChart.noDepartmentsAvailable")}
                      </div>
                    );
                  }

                  return departments.map((dept, index) => {
                    const deptId = dept.value ?? dept.id ?? dept.key;
                    const label = dept.text ?? dept.name ?? this.props.t("app.wallChart.unnamedDepartment");
                    // Compare with loose equality so string "5" and number 5 both match
                    const isSelected = this.state.selectedDepartments.some((s) => s == deptId);
                    return (
                      <label
                        key={deptId != null ? deptId : `dept-${index}`}
                        style={{ display: 'flex', alignItems: 'center', gap: '10px', cursor: 'pointer' }}
                      >
                        <input
                          type="checkbox"
                          checked={!!isSelected}
                          onChange={() => this.handleDepartmentToggle(deptId)}
                          style={{ cursor: 'pointer', width: '18px', height: '18px' }}
                        />
                        <span style={{ fontSize: '14px', color: '#212529' }}>
                          {label}
                        </span>
                      </label>
                    );
                  });
                })()}
              </div>
            </div>
          </Modal.Content>
          <Modal.Actions style={{ padding: '16px 20px', borderTop: '1px solid #e9ecef', display: 'flex', justifyContent: 'flex-end', gap: '12px' }}>
            <button
              onClick={() => this.setState({ showFilterModal: false })}
              style={{
                padding: '8px 16px',
                borderRadius: '8px',
                border: '1px solid #dee2e6',
                background: 'white',
                color: '#6c757d',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => e.target.style.background = '#f8f9fa'}
              onMouseLeave={(e) => e.target.style.background = 'white'}
            >
              {this.props.t("app.common.cancel")}
            </button>
            <button
              onClick={this.applyFilters}
              style={{
                padding: '8px 16px',
                borderRadius: '8px',
                border: 'none',
                background: '#667eea',
                color: 'white',
                fontSize: '14px',
                fontWeight: '500',
                cursor: 'pointer'
              }}
              onMouseEnter={(e) => e.target.style.background = '#5568d3'}
              onMouseLeave={(e) => e.target.style.background = '#667eea'}
            >
              {this.props.t("app.wallChart.applyFilters")}
            </button>
          </Modal.Actions>
        </Modal>
        {/* Header — CommonPageHeader (animated bar) + filter / period panels */}
        <Row className="mb-2 align-items-stretch">
          <Col>
            <CommonPageHeader
              barClassName="wallchart-header-bar office-header-bar"
              contentClassName="office-header-content"
              leftClassName="office-header-left"
              iconWrapperClassName="office-header-icon-wrapper"
              textClassName="office-header-text"
              titleClassName="office-page-title"
              descriptionClassName="office-page-description"
              icon={<i className="bi bi-calendar-week" style={{ fontSize: "20px" }} />}
              title={this.props.t("app.wallChart.title")}
              description={this.renderWallChartHeaderDescription()}
            />
          </Col>
          <Col xs="auto" className="d-flex">
            {/* Action Buttons Box - Similar to Current Period */}
            <div style={{
              background: 'rgba(102, 126, 234, 0.08)',
              borderRadius: '10px',
              padding: '12px',
              border: '1px solid rgba(102, 126, 234, 0.15)',
              minWidth: '200px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              alignSelf: 'stretch'
            }}>
              <div className="d-flex align-items-center mb-2">
                <h6 style={{
                  margin: 0,
                  fontSize: '13px',
                  fontWeight: '600',
                  color: '#1f2937'
                }}>
                  <i className="bi bi-sliders me-1"></i>
                  {this.props.t("app.wallChart.actions")}
                </h6>
              </div>
              <div className="d-flex align-items-center" style={{ gap: '8px', flexWrap: 'wrap' }}>
                {/* Filter Button */}
                <button
                  onClick={() => {
                    const selectedDepts = this.state.selectedDepartmentId === "all" || !this.state.selectedDepartmentId
                      ? ["all"]
                      : [this.state.selectedDepartmentId];
                    this.setState({
                      showFilterModal: true,
                      selectedDepartments: selectedDepts
                    });
                  }}
                  className="btn btn-outline-primary d-flex align-items-center fw-semibold"
                  style={{
                    borderRadius: 8,
                    fontSize: 13,
                    padding: "6px 12px",
                    flex: '1',
                    minWidth: '80px',
                    justifyContent: 'center',
                    height: '32px',
                    lineHeight: '1.2',
                    whiteSpace: 'nowrap'
                  }}
                >
                  <i className="bi bi-funnel-fill me-1" style={{ fontSize: '14px' }}></i>
                  {this.props.t("app.wallChart.filter")}
                  {this.getActiveFilterCount() > 0 && (
                    <span className="badge rounded-pill ms-1" style={{
                      background: '#667eea',
                      color: 'white',
                      fontSize: '10px',
                      padding: '2px 5px'
                    }}>
                      {this.getActiveFilterCount()}
                    </span>
                  )}
                </button>

                {/* Group Leave Button - Only visible to admins */}
                {this.isCurrentUserAdmin() && (
                  <button
                    className="btn btn-outline-primary d-flex align-items-center fw-semibold"
                    onClick={this.handleGroupLeaveClick}
                    style={{
                      borderRadius: 8,
                      fontSize: 13,
                      padding: "6px 12px",
                      flex: '1',
                      minWidth: '80px',
                      justifyContent: 'center',
                      height: '32px',
                      lineHeight: '1.2',
                      whiteSpace: 'nowrap'
                    }}
                  >
                    <i className="bi bi-people-fill me-1" style={{ fontSize: '14px' }}></i>
                    {this.props.t("app.wallChart.bulk")}
                  </button>
                )}
              </div>
            </div>
          </Col>
          <Col xs="auto" className="d-flex">
            {/* Current Period - Date Navigation on Right Side */}
            <div style={{
              background: 'rgba(102, 126, 234, 0.08)',
              borderRadius: '10px',
              padding: '12px',
              border: '1px solid rgba(102, 126, 234, 0.15)',
              minWidth: '240px',
              display: 'flex',
              flexDirection: 'column',
              justifyContent: 'space-between',
              alignSelf: 'stretch'
            }}>
              <div className="d-flex align-items-center justify-content-between mb-2">
                <h6 style={{
                  margin: 0,
                  fontSize: '13px',
                  fontWeight: '600',
                  color: '#1f2937'
                }}>
                  <i className="bi bi-calendar3 me-1"></i>
                  {this.props.t("app.wallChart.currentPeriod")}
                </h6>
                {/* Today Button */}
                {!(this.state.date.isSame(moment(), 'month') && this.state.date.isSame(moment(), 'year')) && (
                  <button
                    className="btn btn-sm"
                    style={{
                      background: 'rgba(102, 126, 234, 0.1)',
                      border: '1px solid rgba(102, 126, 234, 0.2)',
                      color: '#667eea',
                      borderRadius: '8px',
                      fontSize: '11px',
                      padding: '3px 10px',
                      transition: 'all 0.2s',
                      fontWeight: '500'
                    }}
                    onMouseEnter={(e) => {
                      e.target.style.background = 'rgba(102, 126, 234, 0.15)';
                      e.target.style.borderColor = 'rgba(102, 126, 234, 0.3)';
                    }}
                    onMouseLeave={(e) => {
                      e.target.style.background = 'rgba(102, 126, 234, 0.1)';
                      e.target.style.borderColor = 'rgba(102, 126, 234, 0.2)';
                    }}
                    onClick={this.handleToday}
                  >
                    <i className="bi bi-calendar-check me-1"></i>
                    {this.props.t("app.wallChart.today")}
                  </button>
                )}
              </div>

              <div className="d-flex align-items-center justify-content-center">
                <button
                  className="btn btn-link p-0 me-2"
                  style={{
                    color: '#6b7280',
                    textDecoration: 'none',
                    transition: 'all 0.2s',
                    minWidth: 'auto'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#667eea'}
                  onMouseLeave={(e) => e.target.style.color = '#6b7280'}
                  onClick={this.handlePrevMonth}
                >
                  <i className="bi bi-chevron-left" style={{ fontSize: '16px' }}></i>
                </button>

                <div style={{
                  background: 'white',
                  borderRadius: '8px',
                  padding: '6px 12px',
                  minWidth: '100px',
                  textAlign: 'center',
                  border: '1px solid rgba(102, 126, 234, 0.1)'
                }}>
                  <div style={{
                    fontSize: '16px',
                    fontWeight: '700',
                    lineHeight: '1.2',
                    color: '#1f2937'
                  }}>
                    {currentMonth}
                  </div>
                  <div style={{
                    fontSize: '12px',
                    color: '#6b7280',
                    fontWeight: '500'
                  }}>
                    {currentYear}
                  </div>
                </div>

                <button
                  className="btn btn-link p-0 ms-2"
                  style={{
                    color: '#6b7280',
                    textDecoration: 'none',
                    transition: 'all 0.2s',
                    minWidth: 'auto'
                  }}
                  onMouseEnter={(e) => e.target.style.color = '#667eea'}
                  onMouseLeave={(e) => e.target.style.color = '#6b7280'}
                  onClick={this.handleNextMonth}
                >
                  <i className="bi bi-chevron-right" style={{ fontSize: '16px' }}></i>
                </button>
              </div>
            </div>
          </Col>
        </Row>
        <div className="timeTestic-container" style={{ position: 'relative', minHeight: '400px' }}>
          {(this.props.Loading || this.state.isUpdatingFavorite) && (
            <div style={{
              position: 'absolute',
              top: 0,
              left: 0,
              right: 0,
              bottom: 0,
              backgroundColor: 'rgba(255, 255, 255, 0.95)',
              zIndex: 9999,
              display: 'flex',
              alignItems: 'center',
              justifyContent: 'center',
              borderRadius: '12px',
              pointerEvents: 'auto'
            }}>
              <FetchingSpinner text={this.state.isUpdatingFavorite ? this.props.t("app.common.updating") : this.props.t("app.wallChart.loadingFolks")} />
            </div>
          )}
          <div className="timeTestic-list">
            <div className="employee-list-grid mainCalander">
              <Table singleLine>
                <Table.Header>
                  <Table.Row>
                    <Table.HeaderCell />
                    <Table.HeaderCell>
                      <RenderWeekHeader date={this.state.date} />
                    </Table.HeaderCell>
                  </Table.Row>
                </Table.Header>
                <Table.Body>
                  {this.renderEmployee(this.props.employeeLeaves)}
                  {/* Loading indicator when loading more data */}
                  {this.state.isLoadingMore && (
                    <Table.Row>
                      <Table.Cell colSpan="2" style={{ textAlign: 'center', padding: '20px' }}>
                        <FetchingSpinner text={this.props.t("app.wallChart.loadingMoreFolks")} />
                      </Table.Cell>
                    </Table.Row>
                  )}
                </Table.Body>
              </Table>
            </div>
          </div>

        </div>
      </Container>
    );
  }
}

const mapStateToProps = ({ timeOffReducer, companyReducer, officeReducer, userReducer }) => {
  const {
    employeeLeaves,
    Loading,
    timeOffModal,
    timeOffModalErrors,
    leaveTypes,
    startingLeave,
    endingLeave,
    validation,
    pagination,
  } = timeOffReducer;
  const { officeBusinessDays } = officeReducer;

  const { selectedCompany } = companyReducer;
  const { departments } = userReducer || {};

  return {
    employeeLeaves,
    Loading,
    timeOffModal,
    timeOffModalErrors,
    startingLeave,
    endingLeave,
    leaveTypes,
    validation,
    pagination,
    company: selectedCompany,
    officeBusinessDays,
    departments,
  };
};
const mapDispatchToProps = (dispatch) => {
  return {
    timeOff: bindActionCreators(timeOffActions, dispatch),
    officeActions: bindActionCreators(officeActions, dispatch),
    dispatch,
  };
};

export default withTranslation()(connect(mapStateToProps, mapDispatchToProps)(EmployeesCalender));

/* Add this style to improve the hover effect for the Go to Current Month button */
const style = document.createElement('style');
style.innerHTML = `
  .go-current-month-btn:hover, .go-current-month-btn:focus {
    background: #fd7e14 !important; /* Orange shade */
    color: #fff !important;
    border-color: #fd7e14 !important;
    box-shadow: 0 2px 8px rgba(253,126,20,0.12);
  }

  /* Filter Modal Header Styles - Maximum specificity */
  body .filter-modal.ui.modal > .header.filter-modal-header,
  body .ui.modal.filter-modal > .header.filter-modal-header,
  body .filter-modal .ui.modal > .header.filter-modal-header,
  .filter-modal.ui.modal > .header.filter-modal-header,
  .ui.modal.filter-modal > .header.filter-modal-header,
  .filter-modal .ui.modal > .header.filter-modal-header,
  body .ui.modal > .header.filter-modal-header,
  .ui.modal > .header.filter-modal-header,
  .filter-modal-header {
    background: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    background-color: #667eea !important;
    background-image: linear-gradient(135deg, #667eea 0%, #764ba2 100%) !important;
    color: #ffffff !important;
    padding: 24px 28px !important;
    border-bottom: none !important;
    border-radius: 16px 16px 0 0 !important;
    display: flex !important;
    align-items: center !important;
    justify-content: space-between !important;
    position: relative !important;
    overflow: hidden !important;
    box-shadow: 0 2px 8px rgba(102, 126, 234, 0.15) !important;
    margin: 0 !important;
    margin-top: 0 !important;
    margin-bottom: 0 !important;
  }

  body .filter-modal.ui.modal > .header.filter-modal-header *,
  body .ui.modal.filter-modal > .header.filter-modal-header *,
  body .filter-modal .ui.modal > .header.filter-modal-header *,
  .filter-modal.ui.modal > .header.filter-modal-header *,
  .ui.modal.filter-modal > .header.filter-modal-header *,
  .filter-modal .ui.modal > .header.filter-modal-header *,
  body .ui.modal > .header.filter-modal-header *,
  .ui.modal > .header.filter-modal-header *,
  .filter-modal-header * {
    color: #ffffff !important;
  }

  body .filter-modal.ui.modal > .header.filter-modal-header button,
  body .ui.modal.filter-modal > .header.filter-modal-header button,
  .filter-modal.ui.modal > .header.filter-modal-header button,
  .ui.modal.filter-modal > .header.filter-modal-header button,
  .filter-modal-header button {
    color: #ffffff !important;
  }

  /* Fix white border radius issue */
  body .filter-modal.ui.modal,
  body .ui.modal.filter-modal,
  .filter-modal.ui.modal,
  .ui.modal.filter-modal {
    border: none !important;
    overflow: hidden !important;
    border-radius: 16px !important;
  }

  body .filter-modal.ui.modal > .content,
  body .ui.modal.filter-modal > .content,
  .filter-modal.ui.modal > .content,
  .ui.modal.filter-modal > .content {
    border-radius: 0 0 16px 16px !important;
    margin: 0 !important;
    border-top: none !important;
    background: #ffffff !important;
    overflow: hidden !important;
  }

  body .filter-modal.ui.modal > .header.filter-modal-header + .content,
  body .ui.modal.filter-modal > .header.filter-modal-header + .content,
  .filter-modal.ui.modal > .header.filter-modal-header + .content,
  .ui.modal.filter-modal > .header.filter-modal-header + .content {
    margin-top: 0 !important;
  }

  /* Responsive styles for the workplace header */
  @media (max-width: 768px) {
    .workplace-header-container {
      padding: 12px 16px !important;
      margin-bottom: 16px !important;
      margin-left: 16px !important;
      margin-right: 16px !important;
    }
    
    .workplace-header-container h1 {
      font-size: 20px !important;
    }
    
    .workplace-header-container .workplace-context {
      font-size: 13px !important;
    }

    .workplace-header-container .workplace-info p {
      font-size: 11px !important;
      max-width: 100% !important;
    }
    
    .workplace-header-container .date-navigation {
      min-width: 100% !important;
      margin-top: 12px !important;
    }
    
    .workplace-header-container .d-flex.flex-wrap {
      flex-direction: column !important;
      align-items: stretch !important;
    }
    
    .workplace-header-container .workplace-info {
      margin-bottom: 12px !important;
    }

    .workplace-header-container .breadcrumb-nav {
      font-size: 11px !important;
      gap: 6px !important;
    }
  }

  @media (max-width: 576px) {
    .workplace-header-container {
      padding: 10px 12px !important;
      margin-left: 12px !important;
      margin-right: 12px !important;
    }
    
    .workplace-header-container h1 {
      font-size: 18px !important;
    }
    
    .workplace-header-container .breadcrumb-nav {
      font-size: 10px !important;
      gap: 4px !important;
    }
    
    .workplace-header-container .date-navigation {
      padding: 10px !important;
      min-width: 200px !important;
    }

    .workplace-header-container .workplace-context {
      font-size: 12px !important;
    }

    .workplace-header-container .workplace-info p {
      font-size: 10px !important;
      line-height: 1.2 !important;
    }
  }

  /* Smooth transitions for interactive elements */
  .workplace-header-container * {
    transition: all 0.2s ease-in-out;
  }

  /* Enhanced hover effects */
  .workplace-header-container .date-navigation button:hover {
    transform: translateY(-1px);
    box-shadow: 0 4px 12px rgba(255,255,255,0.2);
  }

  .workplace-header-container .breadcrumb-item:hover span {
    opacity: 1 !important;
  }

  /* Animation keyframes */
  @keyframes fadeInUp {
    from {
      opacity: 0;
      transform: translateY(20px);
    }
    to {
      opacity: 1;
      transform: translateY(0);
    }
  }

  /* Enhanced visual hierarchy */
  .workplace-header-container .workplace-context strong {
    text-shadow: 0 1px 2px rgba(0,0,0,0.1);
  }

  .workplace-header-container .date-navigation {
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
  }

  /* Loading state for workplace info */
  .workplace-header-container.loading .workplace-context {
    opacity: 0.6;
  }

  .workplace-header-container.loading .workplace-context::after {
    content: '';
    display: inline-block;
    width: 12px;
    height: 12px;
    border: 2px solid rgba(255,255,255,0.3);
    border-radius: 50%;
    border-top-color: white;
    animation: spin 1s ease-in-out infinite;
    margin-left: 8px;
  }

  @keyframes spin {
    to { transform: rotate(360deg); }
  }
`;
if (!document.head.querySelector('style.go-current-month-btn-style')) {
  style.className = 'go-current-month-btn-style';
  document.head.appendChild(style);
}
